// Total verbs (entries with a verbType) across public/vocab-data/n1-n5.json -
// the same pool ConjugationPage.tsx filters from. Kept as a constant so the
// homepage progress bar doesn't have to download every level's word list
// just to count them - verbTotal.test.ts fails if the data files drift.
export const VERB_TOTAL = 2733;
